import BaseModel from '../base/BaseModel.model';

export default class UserRole extends BaseModel {

    public roleId?: number;
    
    constructor(public userId?: number){
        super();
        this.init();
    }

    init(){
        this.id = 0;
        this.roleId = 0;
        this.userId = 0;
    }
}